import Request from '../../lib/exchange/request'
import RequestTypes from '../../lib/exchange-api/request-types'

class GetUiConfigRequest extends Request {
    constructor() {
        super({
            req: RequestTypes.GET_UI_CFG,
            req_id: 0,
        });
    }
}

export default GetUiConfigRequest;